import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../App';
import { ApiGetCall, ApiGetCallAuthKey, ApiPostCall } from '../../JS/Connector';
import { LogInSchoolID, compressImage, convertToBase64 } from '../../JS/Common';
import { CheckValidation, ValidateFile } from '../../Components/Validations';
import AlertsComp from '../../Components/AlertsComp';
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { useDispatch } from 'react-redux';
import { setUserTimeZone } from '../../Store/Slices/authSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import useConfig from '../../Hooks/useConfig';
import SettingBoxWrapper from './SettingBoxWrapper';

export default function SchoolDetails({ setLoading, setNewAlerts }) {
    const { dynamic_brand_text, specific_cap_school } = useConfig();
    const reduxDispatch = useDispatch();
    const { UserData, setUserData } = useContext(UserContext);
    const [postImage, setPostImage] = useState({ myFile: "" });
    const [previewLogoDiv, setPreviewLogoDiv] = useState('d-none');
    const [InvalidSchoonm, setInvalidSchoonm] = useState("");
    const [image, setImage] = useState(null);
    const [crop, setCrop] = useState({
        unit: "%",
        width: 30,
        x: 0,
        y: 0,
        width: 100,
        height: 100,
        aspectRatio: 1 / 1,
        minWidth: 0,
        minHeight: 0,
        maxWidth: Infinity,
        maxHeight: Infinity,
    });
    const [result, setResult] = useState(null);
    const [BatchData, setBatchData] = useState({
        batchname: "",
        SchoolNm: '',
        timezone: '',
    })
    const [SchoolLogo, setSchoolLogo] = useState('')
    const [allTimeZone, setAllTimeZone] = useState([])
    useEffect(() => {
        GetSchoolData();
        GetAllTimeZone();
    }, []);

    async function GetSchoolData() {
        await ApiGetCall(`/schools/address-by-id?schoolId=${LogInSchoolID}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setBatchData({
                    ...BatchData,
                    SchoolNm: responseRs.school_name || '',
                    timezone: responseRs.school_time_zone_id || 0,
                });
                setSchoolLogo(responseRs.logo || '');
            }
        });

    }
    async function GetAllTimeZone() {
        await ApiGetCallAuthKey("/settings/time-zones").then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setAllTimeZone(responseRs);
            }
        });

    }
    async function handleFileUpload(e) {
        setPostImage({ ...postImage, myFile: '' });
        const file = e.target.files[0];
        if (!file) return;
        const { isFileValid, validationMsg } = ValidateFile(file, { allowedType: "image", maxSizeMB: 2 });
        if (!isFileValid) {
            setNewAlerts(<AlertsComp show={true} variant="danger" msg={validationMsg} />);
            setTimeout(() => {
                setNewAlerts(<AlertsComp show={false} />)
            }, 2000);
            e.target.value = "";
            return;
        }
        const compressedImg = await compressImage(file);
        const base64 = await convertToBase64(compressedImg);
        if (base64) {
            setPreviewLogoDiv('');
            setSchoolLogo('');
        } else {
            setPreviewLogoDiv('d-none')
        }
        setPostImage({ myFile: base64 });
        e.target.value = "";
    };
    async function getCroppedImg() {
        try {
            if (!image) return null;
            const canvas = document.createElement("canvas");
            const scaleX = image.naturalWidth / image.width;
            const scaleY = image.naturalHeight / image.height;
            canvas.width = crop.width;
            canvas.height = crop.height;
            const ctx = canvas.getContext("2d", { alpha: true });
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(
                image,
                crop.x * scaleX,
                crop.y * scaleY,
                crop.width * scaleX,
                crop.height * scaleY,
                0,
                0,
                crop.width,
                crop.height
            );
            const generatedResult = canvas.toDataURL("image/png");
            setResult(generatedResult);
            return generatedResult;
        } catch (e) {
            alert("Something went wrong");
            return null;
        }
    }
    async function UpdateSetting() {
        var isFormValid = CheckValidation({ formID: 'CreateBatchDiv' });
        if (!isFormValid) return;
        setLoading(true);
        let finalResult = result;
        if (postImage.myFile && !result && image) {
            finalResult = await getCroppedImg();
        }
        const uploadedlogo = finalResult || postImage.myFile || SchoolLogo;
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            uploadLogo: uploadedlogo || null,
            schoolName: BatchData.SchoolNm,
            timeZoneId: BatchData.timezone,
        });
        await ApiPostCall("/settings/additional", raw).then((response) => {
            if (response == undefined || response == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(response);
                if (responseRs.status == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={`${specific_cap_school} Details Updated Successfully`} />);
                    setUserData({ ...UserData, schoollogo: uploadedlogo })
                    reduxDispatch(setUserTimeZone(responseRs?.user_time_zone || "America/New_York"));
                    setTimeout(function () {
                        setNewAlerts(<AlertsComp show={false} />)
                        GetSchoolData();
                    }, 1500);
                } else if (responseRs.status == "error") {
                    setInvalidSchoonm(responseRs.msg)
                    // reduxDispatch(setUserTimeZone(responseRs?.user_time_zone || "America/New_York"));
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }
    function handleInputChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        setBatchData({
            ...BatchData,
            [name]: value
        })
    }
    return (
        <>
            <SettingBoxWrapper BoxTitle={`Update ${specific_cap_school} Details`} addPaddingTop={false}>
                <div className="row pe-0 parent" id="CreateBatchDiv">
                    <div className="col-xl-4 col-12 pt-3 ">
                        <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>{dynamic_brand_text} Account Name*</div>
                        <input type="text" autoComplete='off' name='SchoolNm' className="form-control" required
                            value={BatchData.SchoolNm} onChange={handleInputChange} />
                        <span className="form-text invalid-feedback" >
                            *required
                        </span>
                    </div>
                    <div className="col-xl-4 col-12 pt-3">
                        <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Set Time Zone*</div>
                        <select required name='timezone' onChange={handleInputChange}>
                            <option value="0">Select</option>
                            {allTimeZone.map((item, i) => {
                                return <option key={i} value={item.id} selected={BatchData.timezone == item.id}>{item?.timezone} - {item?.description}</option>
                            })}
                        </select>
                        <span className="form-text invalid-feedback" >
                            *required
                        </span>
                    </div>
                    <div className="col-xl-4 pt-3">
                        <div className='col-12 text-start px-1 shipdevice-font-style'>Upload Logo</div>
                        <form className="col-12">
                            <input type="file" label="Image" name="myFile" accept=".jpg,.png,.jpeg" id="UploadFileId" onChange={(e) => handleFileUpload(e)} />
                            <label className="ImportInventoryBtn col-md-9 col-9" htmlFor="UploadFileId">Upload logo</label>
                            <label className="ImportInventoryBtn1 col-md-3 col-3 text-center" htmlFor="UploadFileId" style={{ color: "white" }}>
                                Browse
                            </label>
                        </form>
                    </div>
                    <div className="p-3 ps-1 row">
                        {SchoolLogo ? (
                            <div className="col-12 text-center position-relative" style={{ width: 'fit-content', margin: '0 auto' }}>
                                <img src={SchoolLogo} alt="school logo" className='img-fluid' style={{ height: "100px", width: "100px" }} />
                                <span data-bs-toggle="tooltip" title="Remove Logo">
                                    <FontAwesomeIcon
                                        icon={faTrash}
                                        className="cursor-pointer position-absolute"
                                        style={{ top: '-10px', right: '0px', backgroundColor: 'white', borderRadius: '50%', padding: '4px 2px', color: 'red', border: '1px solid' }}
                                        onClick={() => {
                                            setSchoolLogo('');
                                            setPostImage({ myFile: '' });
                                            setResult(null);
                                            setPreviewLogoDiv('d-none');
                                            document.getElementById('UploadFileId').value = '';
                                        }}
                                    />
                                </span>
                            </div>
                        ) : (
                            <div className={`col-md-12 ${previewLogoDiv}`}>
                                <div className="py-3 uploadLogoDiv">
                                    {postImage.myFile && (
                                        <div className="row">
                                            <div className="col-md-6">
                                                <ReactCrop
                                                    className="cursor-pointer"
                                                    style={{ width: "100%", height: "100%" }}
                                                    src={postImage.myFile}
                                                    onImageLoaded={setImage}
                                                    crop={crop}
                                                    onChange={setCrop}
                                                />
                                            </div>
                                            <div className="col-md-6 position-relative">
                                                {result && (
                                                    <div style={{ width: 'fit-content', margin: '0 auto', position: 'relative' }}>
                                                        <img src={result} alt="cropped image" />
                                                        <span data-bs-toggle="tooltip" title="Remove Logo">
                                                            <FontAwesomeIcon
                                                                icon={faTrash}
                                                                className="cursor-pointer position-absolute"
                                                                style={{ top: '-10px', right: '-10px', backgroundColor: 'white', borderRadius: '50%', padding: '4px 2px', color: 'red', border: '1px solid' }}
                                                                onClick={() => {
                                                                    setSchoolLogo('');
                                                                    setPostImage({ myFile: '' });
                                                                    setResult(null);
                                                                    setPreviewLogoDiv('d-none');
                                                                    document.getElementById('UploadFileId').value = '';
                                                                }}
                                                            />
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <input
                                    type="submit"
                                    value="Preview"
                                    className="SaveBtn upload-save px-3"
                                    onClick={getCroppedImg}
                                    style={{ float: "right" }}
                                />
                            </div>
                        )}
                        <div className='Emailinvalid text-center'>{InvalidSchoonm}</div>
                        <div className="col-12 text-center pt-4">
                            <button className="SaveBtn" onClick={UpdateSetting}> Update Setting   </button>
                        </div>
                    </div>
                </div>
            </SettingBoxWrapper>
        </>
    )
}
